import { AnimatePresence, motion } from "framer-motion";
import { FunctionComponent, ReactNode, useEffect } from "react";
import ReactDOM from "react-dom";
import AnimatedOverlay from "@Components/atoms/AnimatedOverlay";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { ReactComponent as IconX } from "@Icons/16x16/x.svg";
import "./style.scss";

interface Props {
  children: ReactNode;
  display: boolean;
  onDismiss: () => void;
  portal?: boolean;
  showCloseButton?: boolean;
}

const BottomSheet: FunctionComponent<Props> = ({
  children,
  display,
  onDismiss,
  portal = true,
  showCloseButton = false,
}) => {
  const bottomSheetRoot = document.getElementById("bottomSheet-root");

  useEffect(() => {
    document.body.classList.toggle("noScroll", display);
  }, [display]);

  const bottomSheetChildren = (
    <>
      {showCloseButton && (
        <ButtonSmily
          icon={<IconX />}
          iconPosition="alone"
          onClick={onDismiss}
          size="xs"
          type="tertiary"
        />
      )}
      {children}
    </>
  );

  return (
    <>
      {portal ? (
        ReactDOM.createPortal(
          <AnimatePresence>
            {display && (
              <motion.div>
                <AnimatedOverlay onClick={onDismiss} onFullPage={true} />
                <motion.div
                  animate={{
                    y: 0,
                  }}
                  className="BottomSheet"
                  exit={{ y: "100%" }}
                  initial={{ y: "100%" }}
                  transition={{
                    damping: 40,
                    stiffness: 300,
                    type: "spring",
                  }}
                >
                  {bottomSheetChildren}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>,
          bottomSheetRoot || document.body
        )
      ) : (
        <motion.div>
          {display && <AnimatedOverlay onClick={onDismiss} onFullPage={true} />}
          <motion.div
            animate={display ? "open" : "close"}
            className="BottomSheet"
            transition={{
              damping: 40,
              stiffness: 300,
              type: "spring",
            }}
            variants={{
              close: { opacity: 0, y: "100%" },
              open: { opacity: 1, y: 0 },
            }}
          >
            {bottomSheetChildren}
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default BottomSheet;
